import { checkoutService } from '@afterpaytouch/portal-api/consumer/checkout'

export const {
  useGetPayableOrderTransactionsQuery,
  useLazyGetCheckoutPpaDocumentQuery,
  endpoints: { getPayableOrderTransactions, getCheckoutPpaDocument },
} = checkoutService
